import { API_URL } from "src/core/constants";

export type Church = NonNullable<Window["__CHURCH__"]>;

/**
 * Whose hub this is. Node puts it in the page it renders, so it's there before anything paints;
 * elsewhere, as in development, `loadChurch` fetches it before the app renders.
 */
export const church: Church = {
    id: "",
    slug: "",
    name: "",
    shortName: "",
    appName: "Hub",
    brandColour: "#3551A0",
    websiteUrl: null,
    images: {},
    ...window.__CHURCH__,
};

/** Reads the church from the API when the page didn't carry it, and paints its colours */
export const loadChurch = async () => {
    if (window.__CHURCH__) {
        return;
    }

    try {
        const response = await fetch(`${API_URL}/public/church`);

        if (!response.ok) {
            return;
        }

        const { themeCss, ...settings }: Church & { themeCss: string } = await response.json();

        Object.assign(church, settings);

        const style = document.createElement("style");

        style.textContent = themeCss;
        document.head.appendChild(style);
    } catch {
        // The app still opens, in the build's colours and without the church's name
    }
};
